// extracted by mini-css-extract-plugin
export var colorSquare = "_mk-0";
export var danger = "_mk-5";
export var lightPink = "_mk-8";
export var neutralBlue = "_mk-7";
export var neutralYellow = "_mk-6";
export var normal = "_mk-1";
export var primary = "_mk-2";
export var primaryLight = "_mk-3";
export var solidBlack = "_mk-g";
export var solidGreen = "_mk-b";
export var solidLightBlue = "_mk-d";
export var solidNavy = "_mk-c";
export var solidOrange = "_mk-f";
export var solidPink = "_mk-e";
export var solidRed = "_mk-9";
export var solidYellow = "_mk-a";
export var success = "_mk-4";